"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var EntityInfo_1 = require("./EntityInfo");
/**
 * Get Entity object from an entity root element
 * @param element The entity root element. If this element is not an entity root element,
 * it will return null
 */
function getEntityFromElement(element) {
    var entityInfo = EntityInfo_1.deserialzeEntityInfo(element === null || element === void 0 ? void 0 : element.className);
    return entityInfo
        ? __assign({ contentNode: element }, entityInfo) : null;
}
exports.default = getEntityFromElement;
//# sourceMappingURL=getEntityFromElement.js.map